<template>
	<div class="layout-profile" v-if="profile">
		<div>
			<ImageFromServer :src="profile.avatar"/>
		</div>
		<button class="p-link layout-profile-link" @click="onClick">
			<span class="username">{{ profile.name }}</span>
			<i class="pi pi-fw pi-cog"></i>
		</button>
        <transition name="layout-submenu-wrapper">
            <ul v-show="expanded">
                <li>
					<router-link :to="{name: 'account'}" >
						<button class="p-link">
							<i class="pi pi-fw pi-user"></i>
							<span>{{ $t('profileMenu.accountPage') }}</span>
						</button>
					</router-link>
				</li>
                <li><button @click.prevent="logout" class="p-link"><i class="pi pi-fw pi-power-off"></i><span>{{ $t('profileMenu.logoutLink') }}</span></button></li>
            </ul>
        </transition>

	</div>
</template>

<script>
	import AuthBusiness from "@/business/AuthBusiness";
	import EventBus from "@/commons/EventBus";
	import store from "@/store";
	import ImageFromServer from "@/components/image/ImageFromServer";

	export default {
		components: {ImageFromServer},
		data() {
			return {
				expanded: false,
				profile: null,
				loadAvatar: true
			}
		},

		async mounted(){
			this.profile = store.getLoggedUser();
			EventBus.$on('UPDATE_PROFILE', (user) => {
        this.profile = null;
        setTimeout(() => {
          this.profile = {...user};
          store.setLoggedUser(user);
        }, 5);
			});
		},

		methods: {
			onClick(event){
				this.expanded = !this.expanded;
				event.preventDefault();
			},

			async logout(){
				await AuthBusiness.logout();
				EventBus.logout();
			}

		},

		beforeDestroy() {
			EventBus.$off('UPDATE_PROFILE');
		}
	}
</script>

<style scoped>

	.layout-profile img {
		width: 75px;
		border-radius: 80px;
	}

</style>
